var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"annual-toggle-green-savings-pill"},[_c('SwitchToggle',{attrs:{"config":_vm.toggleConfig},on:{"toggle":_vm.toggle}}),_vm._v(" "),_c('PillComponent',{attrs:{"className":"save-message","textValue":"Save 23%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }